import {SupportedLocale} from '@/initializers/i18next';
import {Endpoints, API} from '../api';

export enum UserProfileCompletionStatus {
  Complete = 'complete',
  Incomplete = 'incomplete',
  Verify = 'verify',
}

export interface UserProfileCompletionMetadata {
  status: UserProfileCompletionStatus;
  differentFields: string[];
  missingFields: string[];
}

export interface AdvisorExcerpt {
  advisorId: string;
  lastName: string;
  firstName: string;
  email: string;
  codes: string[];
}

export enum AdvisorType {
  BenevaFinancialAdvisor = 'benevaFinancialAdvisor',
  ExternalFinancialAdvisor = 'externalFinancialAdvisor',
  Unknown = 'unknown',
}

export enum AdvisorRole {
  Advisor = 'advisor',
  Assistant = 'assistant',
  Employee = 'employee',
}

export interface UserProfileInput {
  language: SupportedLocale;
  cons1_lastName: string;
  cons2_firstName: string;
  cons16_isFundServe: boolean;
  cons9_generalAgentCode: string;
  cons25_advisorCode: string;
  cons12_altAdvisorCode1: string | null;
  cons13_altAdvisorCode2: string | null;
  cons14_altAdvisorCode3: string | null;
  cons15_altAdvisorCode4: string | null;
  cons4_email: string;
  cons6_phoneNumber: string;
  cons7_phoneExtension: string | null;
  cons8_generalAgentName: string | null;
  cons10_generalAgentEmail: string | null;
}

export interface UserProfile extends UserProfileInput {
  completionMetadata: UserProfileCompletionMetadata;
  advisorType: AdvisorType;
  advisorRole: AdvisorRole;
  delegatedAdvisors: AdvisorExcerpt[];
  orphanCodes: string[];
}

export function getProfile() {
  return API.get<UserProfile>(Endpoints.users.profile);
}

export function updateProfile(updatedProfile: UserProfileInput) {
  return API.put<UserProfile>(Endpoints.users.profile, updatedProfile);
}
